<template>
  <div class="recording__wrapper">
    <div class="recording__container">
      <div class="recording__info">
        <p class="recording__info-subtitle">живий кастинг</p>
        <h2 class="recording__info-title">
          У студії ми знімаємо твої відео-проби та робимо фото.
        </h2>
        <h2 class="recording__info-title-thin">
          Кастинг-директор допоможе тобі розкритись.
        </h2>
      </div>
      <div class="recording__content">
        <div class="recording__content-left">
          <div class="div recording__content-left-text">
            <p class="recording__content-left-bold">
              У вартість входить жива кастинг-сесія
            </p>
            На відміну від портфоліо з «ідеальною картинкою», тут нічого не
            ховають — режисер бачить тебе справжнього.
          </div>
          <div class="recording__content-left-text">
            <p class="recording__content-left-bold">
              Формат живого кастингу включає:
            </p>
            <div class="recording__list">
              <div v-for="item in list" class="recording__list-item" key="item">
                <div class="recording__list-dot"></div>
                <div class="recording__list-text">{{ item }}</div>
              </div>
            </div>
          </div>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeqH_MlJWDVN0OUicbCBT2CMPqYCCc5VqSzXFQw7Eds39FHWQ/viewform"
          >
            <div class="recording__content-left-button">
              Записатися на проби
            </div>
          </a>
        </div>
        <div class="recording__content-right">
          <video
            class="recording__content-right-video"
            src="/static/video/studio-recording.mp4"
            autoplay
            muted
            playsinline
            loop
            alt="Альт-текст інтро зображення"
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "recording-block",
  data() {
    return {
      list: [
        "Візитівку — коротку розповідь про себе.",
        "Фото — показуємо тебе з усіх сторін та ракурсів",
        "Ігрові завдання — кастинг-директор проводить тебе через діапазон різних образів і станів.",
        "Демонстрацію здібностей — танець, спів чи твій унікальний талант. (Можливо ти вмієш рухати вухами 😉)",
      ],
    }
  },
}
</script>

<style lang="scss">
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Light.woff2") format("woff2");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.recording {
  &__list {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    &-item {
      display: flex;
      column-gap: 12px;
    }

    &-dot {
      width: 8px;
      height: 8px;
      min-width: 8px;
      border-radius: 8px;
      background-color: #7831f3;
      margin-top: 12px;
    }

    &-text {
      font-size: 20px;
      font-family: "Inter", sans-serif;
      @media (max-width: 600px) {
        font-size: 16px;
      }
    }
  }
  &__wrapper {
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
  }

  &__container {
    padding: 0 74px 160px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 60px;

    &-subtitle {
      font-size: 14px;
      font-weight: 500;
      padding-bottom: 20px;
      text-transform: uppercase;
    }

    &-title {
      font-family: "Inter", sans-serif;
      font-size: 60px;
      line-height: 60px;
      font-weight: 500;
      color: #000000;
      letter-spacing: -0.02em;
      text-align: center;
      max-width: 845px;

      &-thin {
        font-size: 60px;
        line-height: 60px;
        font-weight: 300;
        text-align: center;
        max-width: 845px;
        font-family: "Nyght Serif";
      }
    }
  }

  &__content {
    border-bottom: 1px solid #0000004d;
    border-top: 1px solid #0000004d;
    height: 700px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: stretch;

    &-left {
      padding-top: 60px;
      display: flex;
      flex-direction: column;
      row-gap: 30px;
      margin-right: 12px;
      &-text {
        max-width: 519px;
        font-size: 20px;
        font-family: "Inter", sans-serif;
        @media (max-width: 600px) {
          font-size: 16px;
        }
      }

      &-bold {
        font-family: "Inter", sans-serif;

        font-weight: 700;
        padding-bottom: 14px;
        font-size: 20px;
        @media (max-width: 600px) {
          font-size: 16px;
        }
      }

      &-button {
        background-color: #fcc10f;
        font-family: "Inter", sans-serif;

        display: flex;
        justify-content: center;
        align-items: center;

        width: 222px;
        height: 40px;

        font-size: 14px;
        color: #000000;
        border-radius: 8px;
        margin-left: 18px;
        font-weight: 600;
        text-transform: uppercase;
      }
    }

    &-right {
      width: 100%;
      height: 100%;
      &-video {
        width: 100%;
        height: 100%;
        max-height: 700px;
        object-fit: cover;
      }
    }
  }
}

@media (max-width: 998px) {
  .recording {
    &__content {
      height: 500px;
    }

    &__container {
      padding: 0 24px 116px;
    }
  }
}

@media (max-width: 682px) {
  .recording {
    &__info {
      padding-bottom: 32px;
      &-title {
        font-size: 36px;
        line-height: 36px;

        &-thin {
          font-size: 36px;
          line-height: 36px;
        }
      }
    }
  }
}

@media (max-width: 1159px) {
  .recording {
    &__content {
      display: flex;
      flex-direction: column-reverse;
      height: 100%;
      padding: 32px 0;
      &-left {
        padding-top: 32px;
      }
      &-right {
        max-width: 100%;
        &-video {
          width: 100%;
          height: 100%;
          max-height: 500px;
        }
      }
      &__content {
        &-left {
          &-button {
            width: 100%;
            margin-left: 0;
          }
        }
      }
    }
  }
}
@media (max-width: 500px) {
  .recording {
    &__content {
      &-left {
        &-button {
          width: 100%;
          margin-left: 0;
        }
      }
    }
  }
}
</style>
